export enum PlanType {
  Free = 'free',
  Pro = 'pro',
  ProPlus = 'pro_plus',
  Unlimited = 'unlimited',
  Custom = 'custom',
}
